import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTrashBin24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconTrashBin24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.5 4.5h3a.5.5 0 0 1 .5.5v1h-4V5a.5.5 0 0 1 .5-.5M8.5 6V5a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1H19a.75.75 0 0 1 0 1.5h-.5V18a3 3 0 0 1-3 3h-7a3 3 0 0 1-3-3V7.5H5A.75.75 0 0 1 5 6zm7 1.5H7V18a1.5 1.5 0 0 0 1.5 1.5h7A1.5 1.5 0 0 0 17 18V7.5zm-6 9.5v-6.5a.75.75 0 0 1 1.5 0V17a.75.75 0 0 1-1.5 0m3.5-6.5V17a.75.75 0 0 0 1.5 0v-6.5a.75.75 0 0 0-1.5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTrashBin24);
